import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const SurveyRadioGroup = ({
  directionRow,
  options,
  optionsObjectList,
  name,
  controlFunc,
  selectedOptions,
  checkboxStyles,
  wrapperStyles,
  labelStyles,
  type,
}) => (
  <div
    className={
      directionRow
        ? 'survvey-radio-group__wrapper survvey-radio-group__wrapper--row'
        : 'survvey-radio-group__wrapper'
    }
    style={wrapperStyles}
  >
    {options
      ? options.map((opt, index) => (
          <label
            key={index}
            className="survvey-radio-group__label"
            style={labelStyles}
          >
            <input
              className="survvey-radio-group"
              name={name}
              onChange={controlFunc}
              value={opt}
              checked={selectedOptions === opt}
              type={type}
            />
            <span className="survvey-radio-group__checkmark">{opt}</span>
          </label>
        ))
      : optionsObjectList.map((opt, index) => (
          <label key={index} className="survvey-radio-group__label">
            <input
              className="survvey-radio-group"
              name={name}
              onChange={controlFunc}
              value={opt.value}
              checked={selectedOptions === opt.value}
              type={type}
            />
            <span
              className="survvey-radio-group__checkmark"
              style={checkboxStyles}
            />
            {opt.label && opt.label}
          </label>
        ))}
  </div>
);

SurveyRadioGroup.propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  optionsObjectList: PropTypes.array,
  selectedOptions: PropTypes.string,
  controlFunc: PropTypes.func.isRequired,
  directionRow: PropTypes.bool,
  wrapperStyles: PropTypes.object,
  labelStyles: PropTypes.object,
};

export default SurveyRadioGroup;
